import { type Err } from './common';
import { type Bundle, WEAPON_CUES } from './types';

/*
 * Weapon sounds (`items[].weapon.audio.cue`, audio plan §4 item 5): a port of shared-cs ContentValidator.Audio.cs, which is part of
 * `ContentValidator.Warnings` only. A weapon with no cue, a blank cue or a cue the game has no sound for still plays its class sound,
 * so nothing is an error. Same messages in the same order; `validate.audio.test.ts` pins them.
 */

export function validateWeaponAudio(b: Bundle, warn: Err) {
  (b.items ?? []).forEach((it, i) => {
    if (!it?.weapon) return;
    const cue = (it.weapon as { audio?: { cue?: string | null } | null }).audio?.cue ?? '';
    if (cue.trim() === '')
      warn(
        'items',
        i,
        'weapon.audio.cue',
        `Weapon '${it.id ?? ''}' has no audio.cue (it plays the class sound).`,
      );
    else if (!(WEAPON_CUES as readonly string[]).includes(cue))
      warn(
        'items',
        i,
        'weapon.audio.cue',
        `Weapon '${it.id ?? ''}' has unknown audio.cue '${cue}' (it plays the class sound).`,
      );
  });
}
